const translations = {
    fieldView: 'FieldView',
    manageConnections: 'Manage Connections',
    shareError: `An error occured when sending your file to FieldView`,
    shareSuccess: 'Your file was successfully sent to your FieldView inbox'
};

export default translations;
